// extracted by mini-css-extract-plugin
export default {"container":"ts-z","heading":"us-z","text":"vs-z","info":"ws-z","link":"xs-z","fullMaxWidth":"ys-z"};